import React from "react";
import "./experience.css";
import { BsPatchCheckFill } from "react-icons/bs";
import "./experience.css";

const Experience = () => {
  return (
    <section id="experience">
      <h5>My Technical Skills</h5>
      <h2>My Experience</h2>

      <div className="container experience_container">

        {/* Frontend */}
        <div className="experience__frontend">
          <h3>Frontend Development</h3>

          <div className="experience__content">

            {/* <article className="expeience__details">
              <BsPatchCheckFill className="expeience__details-icon" />
              <div>
                <h4>HTML5</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>

            <article className="expeience__details">
              <BsPatchCheckFill className="expeience__details-icon" />
              <div>
                <h4>CSS3</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article> */}

            <article className="expeience__details">
              <BsPatchCheckFill className="expeience__details-icon" />
              <div>
                <h4>JavaScript</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>

            <article className="expeience__details">
              <BsPatchCheckFill className="expeience__details-icon" />
              <div>
                <h4>TypeScript</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>

            <article className="expeience__details">
              <BsPatchCheckFill className="expeience__details-icon" />
              <div>
                <h4>React.js</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>

            <article className="expeience__details">
              <BsPatchCheckFill className="expeience__details-icon" />
              <div>
                <h4> Jotai/Redux/Zustand</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>

            <article className="expeience__details">
              <BsPatchCheckFill className="expeience__details-icon" />
              <div>
                <h4>Next.js</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>

            <article className="expeience__details">
              <BsPatchCheckFill className="expeience__details-icon" />
              <div>
                <h4>Tailwind CSS</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>

          </div>
        </div>

        {/* Backend */}
        <div className="experience__backend">
          <h3>Backend Development</h3>

          <div className="experience__content">

            <article className="expeience__details">
              <BsPatchCheckFill className="expeience__details-icon" />
              <div>
                <h4>Node.js</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>

            <article className="expeience__details">
              <BsPatchCheckFill className="expeience__details-icon" />
              <div>
                <h4>Express.js</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>

            <article className="expeience__details">
              <BsPatchCheckFill className="expeience__details-icon" />
              <div>
                <h4>Nest JS</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>

            <article className="expeience__details">
              <BsPatchCheckFill className="expeience__details-icon" />
              <div>
                <h4>MongoDB</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>

            <article className="expeience__details">
              <BsPatchCheckFill className="expeience__details-icon" />
              <div>
                <h4>Docker</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>

            <article className="expeience__details">
              <BsPatchCheckFill className="expeience__details-icon" />
              <div>
                <h4>AWS Cloud</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>

          </div>
        </div>

      </div>
    </section>
  );
};

export default Experience;